var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowExperienceManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#323232"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7102_3378",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7102_3378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6113 38.6113V26.6667H56.6667V38.6113H38.6113ZM23.3334 53.3334V41.3888H39.7221V53.3334H23.3334ZM23.3334 38.6113V26.6667H35.8334V38.6113H23.3334ZM41.3888 35.8334H53.8888V29.4446H41.3888V35.8334ZM26.1113 50.5554H36.9446V44.1667H26.1113V50.5554ZM26.1113 35.8334H33.0555V29.4446H26.1113V35.8334ZM48.8888 57.1388L48.5834 54.9721C48.0834 54.8149 47.6088 54.6089 47.1596 54.3542C46.7107 54.0995 46.2871 53.7963 45.8888 53.4446L43.9167 54.25L42.3888 51.8054L44.0834 50.4167C43.9537 49.9259 43.8888 49.4213 43.8888 48.9029C43.8888 48.3843 43.9537 47.8796 44.0834 47.3888L42.3888 46L43.9167 43.5279L45.8888 44.3334C46.3055 44 46.7338 43.706 47.1738 43.4513C47.6135 43.1968 48.0834 42.9909 48.5834 42.8334L48.8888 40.6388H51.6667L52 42.8334C52.5 42.9909 52.9699 43.1968 53.4096 43.4513C53.8496 43.706 54.278 44 54.6946 44.3334L56.6667 43.5279L58.1946 46L56.5 47.3888C56.6298 47.8796 56.6946 48.3843 56.6946 48.9029C56.6946 49.4213 56.6298 49.9259 56.5 50.4167L58.1946 51.8054L56.6667 54.25L54.6946 53.4446C54.2963 53.7963 53.8727 54.0995 53.4238 54.3542C52.9746 54.6089 52.5 54.8149 52 54.9721L51.6667 57.1388H48.8888ZM53.0625 51.6738C53.8356 50.9004 54.2221 49.9721 54.2221 48.8888C54.2221 47.8054 53.8356 46.8772 53.0625 46.1042C52.2895 45.3311 51.3613 44.9446 50.278 44.9446C49.1946 44.9446 48.2663 45.3311 47.493 46.1042C46.7199 46.8772 46.3334 47.8054 46.3334 48.8888C46.3334 49.9721 46.7199 50.9004 47.493 51.6738C48.2663 52.4468 49.1946 52.8334 50.278 52.8334C51.3613 52.8334 52.2895 52.4468 53.0625 51.6738Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowExperienceManager);
export default __webpack_public_path__ + "static/media/icon-flow-experience-manager.d9a2962b4a99dc19b9b971cd6adb015c.svg";
export { ForwardRef as ReactComponent };